// import Cookies from "vue-cookies";
// import MixinsApis from '@/api/mixins/home'
export default {
  // computed: {
  //   userInfo() {
  //     return this.$store.state.user.userInfo;
  //   }
  // },
  // mixins: [MixinsApis],
  data() {
    return {
      paybtn: false, //按钮等待
      login: false,
      pickbanner: 0, //轮播图
      imgindex: 0,
      detail: "",
      hotgoods: "", //热门商品
      showlist: true,
      nums: 1,
      is_collect: false, //是否收藏
      showtips: false,
      four: false,
      kucu: false,

      //京东地址
      province: "",
      provinceId: "",
      province1: [],
      city: "",
      cityId: "",
      city1: [],
      town: "",
      townId: "",
      town1: [],
      county: "",
      county1: [],
      pop0: true,
      popAddress: this.$store.state.address,
      datass: [], //精品推荐
      phdatas: [] //排行推荐
    };
  },
  methods: {
    /**
     * 加入购物车
     * @param callBack 备用的回调
     */
    async addcart(id) {
      //this.paybtn=true;
      if (this.paybtn == false) {
        // this.paybtn=true;
        console.log(12);
        if (
          this.$store.state.user_id == "" ||
          this.$store.state.user_id == "null"
        ) {
          this.$alert("用户未登录请先登录", "提示", {
            confirmButtonText: "确定",
            callback: action => {
              router.push({ name: "Login", params: { type: 1 } });
            }
          });
        }
        this.$api.post(
          "user/cart/add",
          {
            id_example: this.$store.state.id_example,
            token_user: this.$store.state.user_id,
            id_product: id,
            number: this.nums,
            status: status
          },
          res => {
            if (res.data.code == 100) {
              this.paybtn == false;
              this.$message({
                message: res.data.message,
                type: "success"
              });
              this.$store.commit("cartnum");
              // if(status==1){
              //     this.showtips = true;
              // }else{
              //     this.payorder(res.data.data)
              // }
            } else if (
              res.data.data == "登录超时" &&
              this.$store.state.user_id != "null"
            ) {
              this.$message({
                message: "请重新登录",
                type: "warning"
              });
              // this.$alert('登录过期请重新登录', '提示', {
              //     confirmButtonText: '确定',
              //     callback: action => {
              //         this.login=true
              //     }
              // });
            }
            this.paybtn = false;
          }
        );

        // let ts= await  this.$api.get('product/detail',{
        //     id_example:this.$store.state.id_example,
        //     user_id:this.$store.state.userinfo.user_id,
        //     id_product:id
        // });
        // console.log(ts)
        // var status
        // this.detail.source==2||this.detail.source==3?status=-1:status=1
      }
    },

    /**
     * 获取商品详情
     * @param callBack 备用的回调
     */
    getdatadetail(id) {
      //获取商品详情
      this.$api.get(
        "product/detail",
        {
          id_example: this.$store.state.id_example,
          user_id: this.$store.state.userinfo.user_id,
          id_product: id
        },
        res => {
          if (res.data.code == 100) {
            this.detail = res.data.data;
            res.data.data.images_run.length < 6
              ? (this.showlist = true)
              : (this.showlist = false);
            res.data.data.is_collect != null
              ? (this.is_collect = res.data.data.is_collect)
              : (this.is_collect = null);
            // if(res.data.data.source==1){
            //     this.checkAddress()
            //     this.adddz()
            // }
          } else {
            this.$message({
              message: res.data.message,
              duration: 1500,
              center: true
            });
            this.$router.push({ name: "Home" });
          }
        },
        err => {
          this.$router.push({ name: "Overtime" });
        }
      );
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./static/js/mixins.js
// module id = null
// module chunks = 